import axios from "axios"
import { SAVE_ACCOUNT_INFO,GET_ACCOUNT,UPDATE_ACCOUNT } from "Utils/URLs";
import React, { useState } from "react";
import { toast } from "react-toastify";

const PaymentState = () => {
    const [formBusy, setFormBusy] = useState(false)
    const [accountResult, setAccountResult] = useState({})
    const [account,setAccount] = useState({})
    const [accountLoading,setAccountLoading] = useState(false)
    const token = localStorage.getItem("token")
   
    const saveAccountInfo = async (data) => {
        try {
            setFormBusy(true)
            const result = await axios.post(SAVE_ACCOUNT_INFO, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }

            )
            if (result.data.type === "success") {
                toast.success(result.data.message)
                setAccountResult(result.data)
            }
            setFormBusy(false)
        } catch (error) {
            console.log("error....",error.response)
            toast.error(error.response.data.message)
            setFormBusy(false)
            
        }
    }

    const getAccountInfo = async()=>{
        try {
            setAccountLoading(true)
            const result = await axios.get(GET_ACCOUNT,{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }

            )
            if(result.data.type==="success"){
                setAccount(result.data.response)
            }
            setAccountLoading(false)
        } catch (error) {
            console.log(error)
            setAccountLoading(false)
        }
    }

    const updateAccountInfo  = async (data)=>{
        try {
            setFormBusy(true)
            const result = await axios.post(UPDATE_ACCOUNT, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }

            )
            if (result.data.type === "success") {
                toast.success(result.data.message)
                setAccountResult(result.data)
            }
            setFormBusy(false)
        } catch (error) {
            console.log(error)
            setFormBusy(false)
        }
    }



    return {
        saveAccountInfo,
        formBusy,
        accountResult,
        getAccountInfo,
        account,
        updateAccountInfo,
        accountLoading
    }

}

export default PaymentState